module.exports = __webpack_public_path__ + "img/1560459373.1262a5ee.jpg";